import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function BeforeAfter() {
  return <section className="px-5 py-14 md:px-8 md:py-20" data-id="element-14" data-mp="68tt5r8t52up">
      <div className="mx-auto max-w-4xl text-center" data-id="element-15" data-mp="3ofrkqupp1f1b">
        <FadeIn data-id="element-16" data-mp="3of837f3ygsnt">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-17" data-mp="3ohu9lbf4124g">
            Una herramienta de trabajo
          </p>
          <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-18" data-mp="3epg7uio17via">
            Tratado Integral de Modernización Laboral
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-stone-300" data-id="element-19" data-mp="3jhznrma6z2q9">
            Todo el material que necesitás para aplicar correctamente la Ley
            27.802 sin perder tiempo redactando cada documento desde cero.
          </p>

          <div className="mx-auto mt-8 flex max-w-xl flex-col items-center justify-center gap-3 border border-accent/30 bg-accent/10 p-5 text-base font-bold text-accent sm:flex-row md:text-lg" data-id="element-20" data-mp="2vqu5l0gs3ycs">
            <span data-id="element-21" data-mp="x3sjumrr3owd">Abrís</span>
            <ArrowRightIcon size={19} aria-hidden="true" data-id="element-22" data-mp="x2z9lbtl2h9h" />
            <span data-id="element-23" data-mp="t3i2yf2f7e2q">Adaptás</span>
            <ArrowRightIcon size={19} aria-hidden="true" data-id="element-24" data-mp="t26yed15i2ak" />
            <span data-id="element-25" data-mp="172hpnh6dhiw9">Presentás</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}